export default __webpack_public_path__ + "static/media/led1.8e3e77f7.png";